export default "__VITE_ASSET__y1tKHxBs__"